import { Phone, ShieldCheck, CalendarCheck } from "lucide-react";
import { BUSINESS } from "../data/business";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { BookingForm } from "../components/Forms";
import { useSEO } from "../hooks/useSEO";

export default function Book() {
  useSEO(
    "Book an Appointment | New Lookz Hair Salon — Gandhi Nagar, Hyderabad",
    "Request an appointment at New Lookz Hair Salon in Gandhi Nagar, Hyderabad. Your time is confirmed once the salon responds.",
    "/book"
  );

  return (
    <section className="bg-ink grain min-h-[80vh]" data-testid="book-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-2 gap-14 items-start">
        <div className="lg:sticky lg:top-28">
          <SectionHeading
            dark
            eyebrow="Book Appointment"
            title="Request Your Chair Time"
            text="Send a request and the salon will confirm your slot by phone. Your requested time is not confirmed until the salon responds."
          />
          <div className="mt-10 space-y-5">
            {[
              { icon: CalendarCheck, text: "Pick your service, date and a preferred time window." },
              { icon: ShieldCheck, text: "The salon confirms your appointment personally — no automated double-bookings." },
              { icon: Phone, text: `Prefer to talk? Call ${BUSINESS.phoneDisplay} directly.` },
            ].map((s, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <div className="flex items-start gap-4">
                  <span className="grid place-items-center w-10 h-10 rounded-full bg-copper/15 text-copper shrink-0">
                    <s.icon size={17} aria-hidden="true" />
                  </span>
                  <p className="text-white/65 text-sm leading-relaxed pt-2">{s.text}</p>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.4}>
              <a href={BUSINESS.phoneHref} data-testid="book-call-btn" className="mt-2 inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 font-display font-semibold text-white text-sm transition-colors hover:border-copper hover:text-copper">
                <Phone size={16} aria-hidden="true" /> Call Now
              </a>
            </Reveal>
          </div>
        </div>
        <Reveal delay={0.15}>
          <div className="rounded-xl bg-paper p-6 sm:p-9 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.8)] border border-copper/20">
            <h2 className="font-display font-extrabold text-ink text-2xl mb-6">Appointment Request</h2>
            <BookingForm />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
